import React, { useEffect, useState } from 'react';

// Importa tus constantes
 import { headers, url } from './utils/const'

function Login() {
    const [userName, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [level, setLevel] = useState('1');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (localStorage.getItem('sessionId')) {
            const userLevel = localStorage.getItem('level');
            if (userLevel === '4') {
                window.location.href = '/bet'
            }else if (userLevel === '5'){
                 window.location.href = '/line'
                }else{
                 window.location.href = '/login'
                };
        }
    }, []);

    const ToChange = (e) => {
        setError('');
        if (e.target.name === 'userName') setUser(e.target.value);
        if (e.target.name === 'password') setPassword(e.target.value);
        if (e.target.name === 'level') setLevel(e.target.value);
    };

    const ToLogin = () => {
        if (!userName || !password) {
            setError('Por favor complete todos los campos');
            return;
        }

        setIsLoading(true);
        setError('');



        // Descomenta para usar tu backend real:
        fetch(`${url}/login`, {
            method: 'post',
            headers: headers,
            body: JSON.stringify({ username: userName, password, level })
        })
        .then(res => res.json())
        .then(data => {
            if (data && data.user && data.name && data.level) {
              console.log('Login exitoso:', data);
                localStorage.setItem('sessionId', data.sessionId);
                localStorage.setItem('user', data.user);
                localStorage.setItem('name', data.name);
                localStorage.setItem('level', data.level);
                localStorage.setItem('point', data.point);
               // document.cookie = `sessionId=${data.sessionId}; path=/`;
                
                if (data.level === '5') {
                    localStorage.setItem('code', data.code);
                }
                
                if (localStorage.getItem('token')) {
                    window.location.href = '/';
                }
            } else {
              console.log('Login fallido:', data);
                setError('Credenciales incorrectas');
                setIsLoading(false);
            }
        })
        .catch(error => {
            console.log(error);
            setError('Error de conexión. Intente nuevamente.');
            setIsLoading(false);
        });
        
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            ToLogin();
        }
    };

    const roles = [
        { value: '1', label: 'Admin', icon: '👑' },
        { value: '2', label: 'Consorcio', icon: '🏢' },
        { value: '3', label: 'Soporte Técnico', icon: '🛠️' },
        { value: '5', label: 'Jugador', icon: '🎮' },
        { value: '4', label: 'Punto de Venta', icon: '🏪' }
    ];

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            <div style={{ width: '100%', maxWidth: '450px' }}>
                {/* Card principal */}
                <div style={{
                    background: 'white',
                    borderRadius: '24px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                    overflow: 'hidden'
                }}>
                    {/* Header con gradiente */}
                    <div style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '40px 32px',
                        textAlign: 'center'
                    }}>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '80px',
                            height: '80px',
                            background: 'rgba(255,255,255,0.2)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '16px',
                            marginBottom: '16px',
                            fontSize: '40px'
                        }}>
                            🔒
                        </div>
                        <h1 style={{
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: 'white',
                            marginBottom: '8px'
                        }}>Bienvenido</h1>
                        <p style={{ color: 'rgba(255,255,255,0.9)' }}>Inicia sesión en tu cuenta</p>
                    </div>

                    {/* Body del formulario */}
                    <div style={{ padding: '32px' }}>
                        {/* Error message */}
                        {error && (
                            <div style={{
                                background: '#fee',
                                border: '1px solid #fcc',
                                color: '#c33',
                                padding: '12px 16px',
                                borderRadius: '12px',
                                fontSize: '14px',
                                marginBottom: '24px'
                            }}>
                                ⚠️ {error}
                            </div>
                        )}

                        {/* Usuario */}
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '8px'
                            }}>Usuario</label>
                            <div style={{ position: 'relative' }}>
                                <span style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '20px',
                                    pointerEvents: 'none'
                                }}>👤</span>
                                <input
                                    type="text"
                                    name="userName"
                                    value={userName}
                                    onChange={ToChange}
                                    onKeyPress={handleKeyPress}
                                    style={{
                                        width: '100%',
                                        paddingLeft: '44px',
                                        paddingRight: '16px',
                                        paddingTop: '12px',
                                        paddingBottom: '12px',
                                        background: '#f9fafb',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '12px',
                                        fontSize: '16px',
                                        outline: 'none',
                                        transition: 'all 0.3s'
                                    }}
                                    placeholder="Ingrese su usuario"
                                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>
                        </div>

                        {/* Contraseña */}
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '8px'
                            }}>Contraseña</label>
                            <div style={{ position: 'relative' }}>
                                <span style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '20px',
                                    pointerEvents: 'none'
                                }}>🔐</span>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    value={password}
                                    onChange={ToChange}
                                    onKeyPress={handleKeyPress}
                                    style={{
                                        width: '100%',
                                        paddingLeft: '44px',
                                        paddingRight: '44px',
                                        paddingTop: '12px',
                                        paddingBottom: '12px',
                                        background: '#f9fafb',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '12px',
                                        fontSize: '16px',
                                        outline: 'none',
                                        transition: 'all 0.3s'
                                    }}
                                    placeholder="Ingrese su contraseña"
                                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '12px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        padding: '4px'
                                    }}
                                >
                                    {showPassword ? '🙈' : '👁️'}
                                </button>
                            </div>
                        </div>

                        {/* Rol */}
                        <div style={{ marginBottom: '32px' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '8px'
                            }}>Seleccione el Rol</label>
                            <div style={{ position: 'relative' }}>
                                <span style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '20px',
                                    pointerEvents: 'none',
                                    zIndex: 1
                                }}>🛡️</span>
                                <select
                                    name="level"
                                    value={level}
                                    onChange={ToChange}
                                    style={{
                                        width: '100%',
                                        paddingLeft: '44px',
                                        paddingRight: '16px',
                                        paddingTop: '12px',
                                        paddingBottom: '12px',
                                        background: '#f9fafb',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '12px',
                                        fontSize: '16px',
                                        outline: 'none',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                >
                                    {roles.map(role => (
                                        <option key={role.value} value={role.value}>
                                            {role.icon} {role.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Botón de Login */}
                        <button
                            onClick={ToLogin}
                            disabled={isLoading}
                            style={{
                                width: '100%',
                                padding: '14px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '12px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                opacity: isLoading ? 0.6 : 1,
                                transition: 'all 0.3s',
                                boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)'
                            }}
                            onMouseEnter={(e) => {
                                if (!isLoading) e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            {isLoading ? '⏳ Iniciando sesión...' : '🚀 Iniciar Sesión'}
                        </button>

                        {/* Footer links */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '24px'
                        }}>
                            <button
                                onClick={() => alert('Funcionalidad de recuperación de contraseña')}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    cursor: 'pointer',
                                    fontWeight: '500'
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                                onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                            >
                                ¿Olvidaste tu contraseña?
                            </button>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <p style={{
                    textAlign: 'center',
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '14px',
                    marginTop: '24px'
                }}>
                    © 2024 Sistema de Gestión. Todos los derechos reservados.
                </p>
            </div>
        </div>
    );
}

export default Login;